import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import First from "./First_section/First";
import Second from "./Second_section/Second";
import Third from "./Third_section/Third";
import Fourth from "./Fourth_section/Fourth";
import Fifth from "./Fifth_section/Fifth";
import Sixth from "./Sixth_section/Sixth";
import Eight from "./Eight_section/Eight";
import Nineth from "./Nineth_section/Nineth";

const Logistic = () => {
  return (
    <>
      <Header />
      <First />
      <Second />
      <Third />
      <Fourth />
      <Fifth />
      <Sixth />
      <Eight />
      <Nineth />
      <Footer />
    </>
  );
};

export default Logistic;
